import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { uploadSingleImage } from './uploads';

/** Egy sajat oleles-hatter (lasd szerver: modules/huddles/backgrounds.ts). */
export interface HuddleBackground {
  id: string;
  /** Relativ cim - az `apiBase()` ele kerul, ahol kell. */
  url: string;
  createdAt: string;
}

const key = ['huddle-backgrounds'] as const;

export function useHuddleBackgrounds(enabled = true) {
  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiFetch<{ backgrounds: HuddleBackground[] }>('/api/users/me/huddle-backgrounds').then(
        (r) => r.backgrounds,
      ),
    enabled,
    staleTime: 5 * 60_000,
  });
}

/** Kep feltoltese, majd hatterre alakitasa - a valasz mar a kesz hatter. */
export function useUploadHuddleBackground() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (file: File) => {
      const fileId = await uploadSingleImage(file);
      const { background } = await apiFetch<{ background: HuddleBackground }>(
        '/api/users/me/huddle-backgrounds',
        { method: 'POST', body: JSON.stringify({ fileId }) },
      );
      return background;
    },
    onSuccess: (background) =>
      queryClient.setQueryData<HuddleBackground[]>(key, (current) => [
        ...(current ?? []),
        background,
      ]),
  });
}

export function useDeleteHuddleBackground() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/users/me/huddle-backgrounds/${id}`, { method: 'DELETE' }).then(() => id),
    onSuccess: (id) =>
      queryClient.setQueryData<HuddleBackground[]>(key, (current) =>
        (current ?? []).filter((item) => item.id !== id),
      ),
  });
}
